angular.module('rjmNg.services').factory 'reportBuilderScalarService', [
  "rjql"
  "rjqlFormula"
  "figureEnums"
  "timeRangeEnums"
  "$q"
  "utils"
  "rjqlStringConstants"
  "encodedLetterString"
  (
    rjql,
    rjqlFormula,
    figureEnums,
    timeRangeEnums,
    $q,
    utils,
    rjqlStringConstants,
    encodedLetterString
  ) ->

    service = {}

    service.generateScalarQuery = (metrics, metric, rbTimeRange, version=0.1) ->
      timeRange = undefined
      if metric.hasCustomTimeRange
        timeRange = utils.copy metric.customTimeRange

        if not timeRange.start? and not timeRange.end?
          timeRange.start = timeRangeEnums.TIME_RANGE_VALUES.START
          timeRange.end = timeRangeEnums.TIME_RANGE_VALUES.END

      else if rbTimeRange.start isnt undefined and
              rbTimeRange.end isnt undefined and
              (version is 1.0 or                 #  in 1.0 the type could be 'All-Time' but we dont want the scalar
               rbTimeRange.type isnt timeRangeEnums.MOVING_TIME_RANGE_TYPES.ALL_TIME) # timeRange to be undefined
        timeRange = rbTimeRange

      measures = []
      # need measures, rows, columns, timerange.
      currentMetric = utils.copy metric
      currentMetric.plot = true
      if currentMetric.type is 'formula'
        # Don't generate a query for a formula that's not yet defined
        if not currentMetric.expression?
          return
        for measure in metrics
          newMeasure = utils.copy measure
          newMeasure.plot = false

          if rjqlFormula.isAliasInExpression(newMeasure.alias, currentMetric.expression)
            measures.push service.convertGroupBysToFilters(newMeasure)
          else
            # we need all source metrics regardless of whether they are used or not in this
            # formula, so that we can properly index when converting the string formula to
            # an expression in the rjqlService
            newMeasure.notInExpression = true
            measures.push newMeasure

      # Convert dimensioning to regular filters so that scalars reflect the grouping
      currentMetric = service.convertGroupBysToFilters(currentMetric)
      measures.push currentMetric
      query = rjql.generateQuery(measures, null, null, timeRange, null, false, version)

      return query

    service.getSingleMeasureFigure = (figure, query) ->
      return o =
        query: query
        data: undefined
        presentation:
          highcharts:
            chart:
              type: 'bar'
          table:
            transpose: false
          scalar:
            truncate: figure?.presentation?.scalar?.truncate
        description: if figure.description? then figure.description else ""
        type:
          id: figureEnums.PRESENTATION_TYPES.SCALAR
        presentationVersion: 0.1
        state:
          id: 1

    service.getScalars = (figure, metrics, timeRange, version=0.1) ->
      metrics.map (metric) ->
        query = service.generateScalarQuery(metrics, metric, timeRange, version)
        if query?
          return o =
            alias: metric.alias
            figure: service.getSingleMeasureFigure(figure, query)
            query: query
        else
          return null

    # Convert a metric's group-by filters to normal filters
    # Used to apply dimensioning to scalars
    service.convertGroupBysToFilters = (metric) ->
      if metric?.type isnt 'metric' or not metric?.dimensions? or metric.dimensions.length is 0
        return metric

      filterStartIndex = metric.filters?.restrictions?.length ? 0

      # filters through metric.dimensions and metric.dimensionValues
      # removes dimensions when the dimensionValue with the same index is empty
      dimensionsWithDimensionValues = _.reject(angular.copy(metric.dimensions), (dimension, index) ->
        return _.isEmpty(metric.dimensionValues[index])
      )
      # removes all empty dimensionValues
      dimensionValuesNonEmpty = _.reject(angular.copy(metric.dimensionValues), (dimensionValue) ->
        return _.isEmpty(dimensionValue)
      )

      if metric.isGaMetric
        filterCurrentIndex = filterStartIndex
        for dimension, index in dimensionsWithDimensionValues \
          when dimension.column_id isnt rjqlStringConstants.RJQL_UNBOUND
            gaSequenceString = ''
            gaDimension = angular.copy dimension
            for dimensionValue in Object.keys(dimensionValuesNonEmpty[index])
              newRestriction =
                left: gaDimension
                op: "IS"
                right: dimensionValue
              metric.filters.restrictions.push newRestriction

              if gaSequenceString is ''
                gaSequenceString += encodedLetterString.indexToAlpha(filterCurrentIndex)
              else
                gaSequenceString += " OR #{encodedLetterString.indexToAlpha(filterCurrentIndex)}"
              filterCurrentIndex++

            if metric.filters.sequence.string?.length > 0
              metric.filters.sequence.string = "(#{metric.filters.sequence.string}) AND (#{gaSequenceString})"
            else
              metric.filters.sequence.string = gaSequenceString
      else # non-ga
        for dimension, index in dimensionsWithDimensionValues \
          when Object.keys(dimensionValuesNonEmpty[index]).length isnt 0 \
          and dimension.column_id isnt rjqlStringConstants.RJQL_UNBOUND
            newRestriction =
              left: angular.copy dimension
              op: 'IN'
              right: Object.keys(dimensionValuesNonEmpty[index])

            metric.filters.restrictions.push newRestriction
            metric.filters.sequence.string =
            if metric.filters.sequence.string?.length > 0
              metric.filters.sequence.string = "(#{metric.filters.sequence.string}) AND #{encodedLetterString.indexToAlpha(filterStartIndex + index)}"
            else
              metric.filters.sequence.string = encodedLetterString.indexToAlpha(filterStartIndex + index)

      metric.dimensions = []
      metric.dimensionValues = []
      return metric

    service

  ]
